Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/common/cloudinaryImages.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/header/headerScroll.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/header/headerNavigation.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/header/minicartSettings.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/footer/footer.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/common/modal.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/common/language.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/common/hero.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/common/cardFree.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/common/addToCart.es');
Liferay.Loader.require('dna-fi-theme-js@7.4.0/js/common/accordion.es');

// fix for WIN phone browsers media queries.
// See eg. http://mattstow.com/responsive-design-in-ie10-on-windows-phone-8.html
(function() {
  if ("-ms-user-select" in document.documentElement.style && navigator.userAgent.match(/IEMobile/)) {
    var msViewportStyle = document.createElement("style");
    msViewportStyle.appendChild(
      document.createTextNode("@-ms-viewport{width:auto!important}")
    );
    document.getElementsByTagName("head")[0].appendChild(msViewportStyle);
  }
})();
